var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 53,
    viewBox: "0 0 111 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2499_3519",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 0,
    width: 36,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.3682 3.28687L105.847 7.10252e-05L108.56 26.8077L76.0811 30.0945L73.3682 3.28687Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2499_3519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.973 12.3566C106.837 15.2367 105.582 17.895 103.445 19.8283C101.444 21.6495 96.1019 25.0375 90.6328 27.5656C89.7538 27.9726 88.9105 28.3381 88.1125 28.665L88.3252 28.3917L88.3455 28.3669C89.0936 27.3597 89.3821 26.1511 89.2297 25.0003C89.2911 24.9713 89.3475 24.9486 89.4087 24.9178C94.5542 22.5398 99.6834 19.3078 101.487 17.6713C103.044 16.2605 103.961 14.3218 104.064 12.2175C104.167 10.1094 103.441 8.09657 102.029 6.53364C100.283 4.61275 97.7929 3.7515 95.3848 3.99519C93.7657 4.15905 92.1857 4.82253 90.8916 5.99096C89.0499 7.65972 85.2783 12.4261 82.3946 17.2123C82.338 17.3071 82.283 17.3997 82.233 17.4862C82.1221 17.6621 82.0218 17.8313 81.927 17.998C81.8292 18.1726 81.7288 18.3399 81.6341 18.5085C80.7627 20.0374 80.1259 21.34 79.6688 22.4351C79.5901 22.6305 79.509 22.8205 79.4385 23.0037C79.361 23.2103 79.2885 23.4107 79.2243 23.599C78.4611 25.7853 78.5807 26.911 78.9179 27.2877C79.1161 27.5061 79.5348 27.6398 80.1059 27.671C79.6819 28.7571 78.7612 29.6113 77.5967 29.928C77.2784 29.7387 77.004 29.5146 76.7609 29.2458C75.5019 27.8605 75.4113 25.6376 76.5087 22.5258C76.5767 22.3372 76.646 22.1428 76.7247 21.9474C76.7927 21.7588 76.8682 21.5694 76.9544 21.3732C77.5373 19.9492 78.349 18.3544 79.371 16.5926C79.4663 16.4314 79.566 16.2567 79.6719 16.0869C79.7407 15.9626 79.8221 15.8313 79.8966 15.7064C79.9226 15.664 79.9471 15.6255 79.9712 15.5833C83.0185 10.5438 86.9153 5.66638 88.9335 3.83399C91.0596 1.90737 93.8246 0.906249 96.7146 1.04732C99.5953 1.18934 102.247 2.43931 104.186 4.5755C106.125 6.7117 107.115 9.47783 106.973 12.3566Z",
    fill: "#0094FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2499_3519",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 91,
    height: 47
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.735352 15.0182L86.4824 6.34064L90.2997 44.0607L4.55259 52.7382L0.735352 15.0182Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2499_3519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.0994 21.3838C73.384 21.6586 71.4082 24.0793 71.683 26.7948C71.9576 29.5083 74.3783 31.4841 77.0937 31.2093C77.5454 31.1636 77.9756 31.0557 78.38 30.8992C78.5282 30.8483 78.6672 30.7812 78.8081 30.7139C78.9414 30.6474 79.0742 30.5753 79.1947 30.4931C80.25 29.8467 81.024 28.8142 81.3532 27.6147C81.3849 27.5168 81.4107 27.4158 81.4287 27.3136C81.4524 27.2109 81.4669 27.1109 81.4793 27.0093C81.54 26.617 81.5519 26.2106 81.5103 25.8002C81.3927 24.6384 80.8844 23.6183 80.1321 22.8443C80.5641 21.7821 81.1929 20.4746 82.0889 18.8902L86.9327 22.9778C87.5173 23.4979 87.8851 24.1763 88.0278 24.8946C88.0508 24.9907 88.0671 25.0951 88.0771 25.1944C88.0875 25.2974 88.092 25.3973 88.097 25.5028C88.1145 26.2565 87.8924 27.0173 87.4076 27.6703L85.9997 29.4542L85.6724 29.8678L85.3552 30.2691L74.0219 44.6305C73.429 45.3759 72.5684 45.8511 71.6239 45.9467L8.0313 52.3822C6.11231 52.5764 4.39329 51.1733 4.1989 49.2525L1.08753 18.5075C0.89257 16.581 2.2964 14.8695 4.21538 14.6753L67.808 8.23976C68.7525 8.14418 69.6907 8.43545 70.4203 9.04127L78.9217 16.2157C77.8077 18.1156 76.944 19.833 76.3324 21.366C76.255 21.3681 76.1744 21.3763 76.0994 21.3838Z",
    fill: "#0094FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponTag);
export default __webpack_public_path__ + "static/media/coupon-tag.aed8361bd09f2682de971c011c46b3fe.svg";
export { ForwardRef as ReactComponent };